import { defineStore } from 'pinia';

export const useUserStore = defineStore('user', {
  state: () => ({
    firstname: '',
    lastname: '',
    email: '',
    telephone: '',
  }),
  getters: {
    getFirstname() {
      return this.firstname;
    },
    getLastname() {
      return this.lastname;
    },
    getEmail() {
      return this.email;
    },
    getTelephone() {
      return this.telephone;
    },
  },
});
